/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Form.Subcomponent` filename
import PropTypes from 'prop-types';
import React from 'react';
// Form/Form* components are exceptions for react-hook-form
// eslint-disable-next-line no-restricted-imports
import { useFormContext, useWatch } from 'react-hook-form';
var FormFieldDependentContent = function (_a) {
    var children = _a.children, shouldRender = _a.shouldRender;
    var control = useFormContext().control;
    // React Hook Form does not trigger re-render when form state changes by default.
    // The `watch` API is provided for this reason, and in essence, makes the form state behave like local state
    var formState = useWatch({
        control: control
    });
    /* eslint-disable-next-line react/jsx-no-useless-fragment */
    return shouldRender(formState) ? React.createElement(React.Fragment, null, children) : null;
};
FormFieldDependentContent.propTypes = {
    /*
     * A callback function to determine whether the children should render. It is called with the current field state
     * so that consumers can use their own external logic to control rendering based on the current field values.
     */
    shouldRender: PropTypes.func.isRequired
};
export default FormFieldDependentContent;
//# sourceMappingURL=Form.FieldDependentContent.js.map